import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/.pnpm/@vercel+analytics@1.5.0_next@15.3.3_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0__react@19.1.0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@1.2.0_next@15.3.3_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1_wubf3ds2dtfffjyj75xgav7r3e/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.3_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/global.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/pop.css");
;
import(/* webpackMode: "eager", webpackExports: ["DarkModeToggle"] */ "/vercel/path0/src/components/DarkModeToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NoSSR"] */ "/vercel/path0/src/components/NoSSR.tsx");
